import { FETCH_ALL_DESTINATION_REQUESTED } from './../../../destination/destination.action';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from './../../../../common/services/notification/notification.service';
import { API_CALL_ERROR } from './../../../../store/action';
import { ApiService } from './../../../../api/api.service';
import { AppInjector } from './../../../../app-injector';
import {
  FETCH_PRODUCTS_LOCATION_REQUESTED,
  FETCH_PRODUCTS_LOCATION_SUCCEEDED,
  SEARCH_PRODUCT_LOCATION_REQUESTED,
  SEARCH_PRODUCT_LOCATION_SUCCEEDED,
  FETCH_TRACKED_PRODUCTS_REQUESTED,
  FETCH_TRACKED_PRODUCTS_SUCCEEDED,
  COMPLETE_SCAN_REQUESTED,
  COMPLETE_SCAN_SUCCEEDED,
  FETCH_EXTRA_PRODUCT_REQUESTED,
  FETCH_EXTRA_PRODUCT_SUCCEEDED,
  MARKED_AS_FOUND_SUCCEEDED,
  MARKED_AS_FOUND_REQUESTED,
  FETCH_LOCATION_OF_TRACKED_PRODUCT_REQUESTED,
  FETCH_LOCATION_OF_TRACKED_PRODUCT_SUCCEEDED,
  REMOVE_SCANNED_ITEM,
  REMOVE_SCANNED_ITEM_SUCCEEDED,
  MOVE_ITEM_TO_LOST_AND_FOUND_DESTINATION,
  RESET_SCAN_REQUESTED,
  RESET_SCAN_SUCCESSED
} from './edit.actions';
import { takeEvery, put, select, takeLatest } from 'redux-saga/effects';
import { PreloaderService } from '../../../../common/services/preloader/preloader.service';
import { SCAN_RACK_COMP, MOVE_TO_LOST_AND_FOUND_DESTINATION_TYPE } from './edit.const';
import * as _ from 'lodash';
import ProductTrack from '../../../../models/ProductTrack';
import { FETCH_ALL_LOCATIONS_REQUESTED, GET_LOCATION_REQUESTED } from '../../../location/location.actions';
import { SAVE_PRODUCT_LOCATION, SAVE_PRODUCT_LOCATION_SUCCEEDED } from '../../batch/batch.actions';

function* getProductsOfLocation(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.inventory.list(action.data).toPromise();
    yield put({ type: FETCH_PRODUCTS_LOCATION_SUCCEEDED, data: results, track_id: action.track_id, location_id: action.location_id });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchProductsOfLocationRequest() {
  yield takeEvery(FETCH_PRODUCTS_LOCATION_REQUESTED, getProductsOfLocation);
}

function* searchProductInLocation(action) {
  const api = AppInjector.get(ApiService);
  try {
    AppInjector.get(PreloaderService).show();
    let result = yield api.track.check(action.data.track_id, action.data.sku).toPromise();
    yield put({ type: SEARCH_PRODUCT_LOCATION_SUCCEEDED, data: result, track_id: action.data.track_id });
    AppInjector.get(PreloaderService).hide();
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    AppInjector.get(NotificationService).show('warning', e.error.message, 5000);
    yield put({ type: FETCH_TRACKED_PRODUCTS_REQUESTED, track_id: action.data.track_id });
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSearchProductInLocationRequest() {
  yield takeEvery(SEARCH_PRODUCT_LOCATION_REQUESTED, searchProductInLocation);
}

function* watchFetchProductsOfLocationSUCCEEDED() {
  yield takeLatest(FETCH_PRODUCTS_LOCATION_SUCCEEDED, function*(action: any) {
    yield put({ type: FETCH_TRACKED_PRODUCTS_REQUESTED, track_id: action.track_id });
  });
}

function* fetchTrackedProducts(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.track.getTrackedProducts(action.track_id).toPromise();
    yield put({ type: FETCH_TRACKED_PRODUCTS_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchTrackedProductRequeted() {
  yield takeLatest(FETCH_TRACKED_PRODUCTS_REQUESTED, fetchTrackedProducts);
}

function* completeScan(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.track.complete(action.data).toPromise();
    yield put({ type: COMPLETE_SCAN_SUCCEEDED, data: result, track_id: action.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchCompleteScanRequest() {
  yield takeEvery(COMPLETE_SCAN_REQUESTED, completeScan);
}

function* getExtraProduct(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.product.getItemBySku(action.data).toPromise();
    let results = yield select(state => (state as any).Inventory.ScanRack.edit.completedTracks);
    yield put({
      type: FETCH_EXTRA_PRODUCT_SUCCEEDED,
      data: _.concat(
        results,
        _.assign(_.clone(result), {
          product_track: new ProductTrack({ status: 2, status_text: 'extra' })
        })
      )
    });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchExtraProductRequest() {
  yield takeEvery(FETCH_EXTRA_PRODUCT_REQUESTED, getExtraProduct);
}

function* reloadListTrackedProduct(action) {
  let track_id;
  if (action.type === COMPLETE_SCAN_SUCCEEDED || action.type === SEARCH_PRODUCT_LOCATION_SUCCEEDED) {
    track_id = action.track_id;
  }
  if (action.type === MARKED_AS_FOUND_SUCCEEDED) {
    track_id = action.data.getId();
  }
  yield put({ type: FETCH_TRACKED_PRODUCTS_REQUESTED, track_id: track_id });
}
function* watchCompleteScanSuccess() {
  yield takeLatest(COMPLETE_SCAN_SUCCEEDED, reloadListTrackedProduct);
  yield takeLatest(MARKED_AS_FOUND_SUCCEEDED, reloadListTrackedProduct);
  yield takeLatest(SEARCH_PRODUCT_LOCATION_SUCCEEDED, reloadListTrackedProduct);
}

function* markAsFound(action) {
  yield put({ type: SEARCH_PRODUCT_LOCATION_REQUESTED, data: action.data });
}

function* watchMarkAsFoundRequest() {
  yield takeEvery(MARKED_AS_FOUND_REQUESTED, markAsFound);
}

function* watchFetchTrackedProductSuccess() {
  yield takeEvery(FETCH_TRACKED_PRODUCTS_SUCCEEDED, function*(action) {
    yield put({ type: FETCH_LOCATION_OF_TRACKED_PRODUCT_REQUESTED, data: (action as any).data });
  });
}

function* fetchLocationOfTrackedProduct(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.inventory.list({ product_skues: _.map(action.data, item => item.getSku()) }).toPromise();
    yield put({ type: FETCH_LOCATION_OF_TRACKED_PRODUCT_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchExtraProductInfoRequest() {
  yield takeEvery(FETCH_LOCATION_OF_TRACKED_PRODUCT_REQUESTED, fetchLocationOfTrackedProduct);
}

function* fetchAllDestination(action) {
  yield put({ type: FETCH_ALL_DESTINATION_REQUESTED, com: SCAN_RACK_COMP });
}

function* fetchAllLocation(action) {
  yield put({ type: FETCH_ALL_LOCATIONS_REQUESTED, com: SCAN_RACK_COMP });
}

function* watchFetchLocationOfTrackedProductSUCCEEDED() {
  yield takeLatest(FETCH_LOCATION_OF_TRACKED_PRODUCT_SUCCEEDED, fetchAllDestination);
  yield takeLatest(FETCH_LOCATION_OF_TRACKED_PRODUCT_SUCCEEDED, fetchAllLocation);
}

function* removeScannedItem(action) {
  try {
    let result = yield AppInjector.get(ApiService)
      .track.removeScannedItem(action.track_id, action.data.getSku())
      .toPromise();
    yield put({ type: REMOVE_SCANNED_ITEM_SUCCEEDED, data: result, product: action.data, track_id: action.track_id });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchRemoveScannedItem() {
  yield takeLatest(REMOVE_SCANNED_ITEM, removeScannedItem);
}

function* moveItemToLostAndFoundDestination(action) {
  const destinations = yield select(state => (state as any).Destination.all.items);
  const lost_and_found_destination = _.find(destinations, item => item.code === 'LOST_AND_FOUND');
  if (!_.isUndefined(lost_and_found_destination)) {
    yield put({
      type: SAVE_PRODUCT_LOCATION,
      data: { product_sku: action.data, destination_id: lost_and_found_destination.id },
      destination: lost_and_found_destination,
      com: SCAN_RACK_COMP,
      btn: MOVE_TO_LOST_AND_FOUND_DESTINATION_TYPE
    });
  }
}

function* watchMoveItemToLostAndFoundDestination() {
  yield takeLatest(MOVE_ITEM_TO_LOST_AND_FOUND_DESTINATION, moveItemToLostAndFoundDestination);
}

function* removeItemFromCurrentScan(action) {
  if (action.com === SCAN_RACK_COMP) {
    const tracked_products = yield select(state => (state as any).Inventory.ScanRack.edit.tracked_products);
    const product_locations = yield select(state => (state as any).Inventory.ScanRack.edit.items);
    const moved_product = _.find(tracked_products, item => item.getId() === action.data.getProductId());
    const current_product_location = _.find(product_locations, item => item.getProductId() === action.data.getProductId());
    if (!_.isUndefined(moved_product) && !_.isUndefined(current_product_location) && current_product_location.getLocationId() !== action.data.getLocationId()) {
      yield put({
        type: REMOVE_SCANNED_ITEM,
        data: moved_product,
        track_id: document.location.pathname.match(/^.*tracks\/(.*)\/location.*$/)[1]
      });
    }
  }
}

function* watchMoveItemToAnotherDestinationSuccessed() {
  yield takeLatest(SAVE_PRODUCT_LOCATION_SUCCEEDED, removeItemFromCurrentScan);
}

function* resetCurrentScan(action) {
  try {
    let result = yield AppInjector.get(ApiService)
      .track.resetCurrentScan(action.track_id)
      .toPromise();
    yield put({ type: RESET_SCAN_SUCCESSED, data: result, product: action.data, query_params: action.data, track_id: action.track_id, location_id: action.location_id });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchResetScanRequested() {
  yield takeLatest(RESET_SCAN_REQUESTED, resetCurrentScan);
}

function* reloadData(action) {
  yield put({
    type: FETCH_PRODUCTS_LOCATION_REQUESTED,
    data: action.query_params,
    track_id: action.track_id,
    location_id: action.location_id
  });
}

function* watchResetScanSuccessed() {
  yield takeLatest(RESET_SCAN_SUCCESSED, reloadData);
}

export default [
  watchFetchProductsOfLocationRequest,
  watchSearchProductInLocationRequest,
  watchFetchProductsOfLocationSUCCEEDED,
  watchFetchTrackedProductRequeted,
  watchCompleteScanRequest,
  watchFetchExtraProductRequest,
  watchCompleteScanSuccess,
  watchMarkAsFoundRequest,
  watchFetchTrackedProductSuccess,
  watchFetchExtraProductInfoRequest,
  watchFetchLocationOfTrackedProductSUCCEEDED,
  watchRemoveScannedItem,
  watchMoveItemToLostAndFoundDestination,
  watchMoveItemToAnotherDestinationSuccessed,
  watchResetScanRequested,
  watchResetScanSuccessed
];
